export default "__VITE_ASSET__CzwQK8Mf__"